<rid-demo-page [title]="'Dictee'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Dictee | Fysiek" variant="PRIMARY" routerLink="physical" />
  <rid-button class="w-full" content="Dictee | Visueel" variant="PRIMARY" routerLink="visual" />
  <rid-button class="w-full" content="Dictee | Digitaal" variant="PRIMARY" routerLink="digital" />
  <rid-button class="w-full" content="Dictee | Zinnen" variant="PRIMARY" routerLink="sentences" />
</rid-demo-page>
